export const determineProductLabel = (today: string, daypartName: string) => {
  switch (today) {
    // TODO: translate these items in the array
    case 'Monday':
      return ['This Week', 'This Week', 'Weekend', 'Weekend'];
    case 'Tuesday':
      return ['This Week', 'This Week', 'Weekend', 'Weekend'];
    case 'Wednesday':
      return ['This Week', 'Weekend', 'Weekend'];
    case 'Thursday':
      return ['Weekend', 'Weekend', 'Next Week', 'Next Week'];
    case 'Friday':
      return ['Sunday', 'Next Week', 'Next Week'];
    case 'Saturday':
      return ['Next Week', 'Next Week'];
    case 'Sunday':
      return ['Next Week', 'Next Week'];
    default:
      return daypartName;
  }
};

/*
  Mon:
      1. (three day) - "This Week" - Wed, Thu, Fri
        Internal Animation - Nighttime low -> Precip Chance
      2. (two day) -  "Weekend" - Sat
      3. (two day cont.) - "Weekend" - Sun
  Tues:
      1. (two day) - "This Week" - Thu
      2. (two day cont.) - "This Week" - Fri
      3. (two day) - "Weekend" - Sat
      Page Four (two day) - "Weekend" - Sun
  Wed:
      1. (two day) - "This Week" - Fri
      2. (two day) - "Weekend" - Sat
      3. (two day cont.) - "Weekend" - Sun
  Thur:
      1. (two day) - "Weekend" - Sat
      2. (two day cont.) - "Weekend" - Sun
      3. (three day) - "Next Week" - Mon, Tue, Wed
         Internal Animation - Nighttime low -> Precip Chance
  Fri:
      1. (two day) - "Sunday"
      2. (three day) - "Next Week" - Mon, Tue, Wed
         Internal Animation - Nighttime low -> Precip Chance
  Sat:
      1. (three day) - "Next Week" - Mon, Tue, Wed
         Internal Animation - Nighttime low -> Precip Chance
  Sun:
      1. (three day) - "Next Week" - Tue, Wed, Thurs
         Internal Animation - Nighttime low -> Precip Chance
*/
